import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { FeedbackService, ReportService } from '@app/core/services';
import { TableConfig } from '@app/interfaces';
import { BaseListComponent } from '../../base-list.component';
import { TableComponent } from '../../table/table.component';
import { SavedReportFilterEntity } from '../models/saved-report-fiter.entity';
import { SavedReportFilterModel } from '../models/saved-report-fiter.model';
import { SavedReportFilterService } from '../services/saved-report-filter.service';

@Component({
	selector: 'sl-load-saved-reportfilters',
	templateUrl: './load-saved-report-filters.component.html',
	standalone: true,
	imports: [TableComponent, MatDialogModule, MatButtonModule],
})
export class LoadSavedReportFiltersComponent extends BaseListComponent<SavedReportFilterEntity, SavedReportFilterService> {
	listingPagePath = '/lsb/saved-report-filter';
	entityName: 'Saved Report Filter';
	selectedSetup: any;
	title: 'Load Saved Report Filter';
	entityData: SavedReportFilterEntity[] = [];
	reportType: number;

	config: TableConfig<SavedReportFilterModel> = {
		...this.config,
		onRowClick: null,
		columns: [
			{
				header: 'Saved Filters',
				key: 'Name',
			},
		],
		actions: [
			{
				label: 'Select',
				onClick: (row: SavedReportFilterModel): void => {
					this.selectedSetup = row;
					this.loadSelectedSetup();
				},
			},
			{
				label: 'Delete',
				onClick: (row: SavedReportFilterModel): void => {
					this.deleteSelectedFilter(row);
				},
			},
		],
	};

	constructor(
		protected readonly listService: SavedReportFilterService,
		protected readonly dialog: MatDialog,
		protected readonly feedbackService: FeedbackService,
		protected readonly route: ActivatedRoute,
		protected readonly router: Router,
		protected readonly reportService: ReportService,
		public dialogRef: MatDialogRef<LoadSavedReportFiltersComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		super(dialog, feedbackService, route, router, reportService);
		this.entityData = data.filters;
		this.reportType = data.reportType;
	}

	loadSelectedSetup(): void {
		this.dialogRef.close(this.selectedSetup);
	}

	cancel(): void {
		this.dialogRef.close();
	}

	deleteSelectedFilter(row: SavedReportFilterModel): void {
		this.listService.deleteEntity(row.Id).subscribe(() => {
			this.feedbackService.success('deleted', 'Saved Report Filter');
			this.entityData = this.entityData.filter((x) => x.Id !== row.Id);
		});
	}
}
